import React from 'react';

const path = process.env.PUBLIC_URL

const Answer = ({ selectedAnswer, correctAnswer, reason, highlight, changedAnswer, answers }) => {
  return (
    <div className="h-full w-full answer overflow-hidden relative">
      <img src={`${path}/images/bg.svg`} className="absolute h-[95%] min-w-[400px] object-cover left-[50%] translate-x-[-50%] bottom-0" />
      { (selectedAnswer === correctAnswer || selectedAnswer === true) ? (
        <div className="h-full w-full">
          <img src={`${path}/images/correct.svg`} className="absolute w-[410px] left-[50%] top-[30px] max-w-[400px] translate-x-[-50%]" />
          <div className="answer__text">答对了😀</div>
        </div>
      ) : (
        <div className="h-full w-full">
          <img src={`${path}/images/wrong.svg`} className="absolute w-[410px] left-[50%] top-[30px] max-w-[400px] translate-x-[-50%]" />
          <div className="answer__text">答错了😮‍💨</div>
        </div>
      )}
      <img src={`${path}/images/eye.svg`} className="absolute w-[120px] left-[50%] translate-x-[-50%] top-[152px]" />
      <div className="absolute w-[80%] top-[38%] left-[10%] answer__highlight">
        {highlight.map((word, index) => 
          typeof correctAnswer === 'string' ? (
            <span key={index} className="relative">
              <span className={word === correctAnswer ? "crossed" : ""}>
                {word}
              </span>
              { correctAnswer === word && (
                <span className="absolute top-10 left-5 whitespace-nowrap text-red">{changedAnswer}</span>
              )}
            </span>
          ) : (
            <span key={index} className="relative">
              <span className={correctAnswer.includes(word) ? "crossed" : ""}>{word}</span>
              {correctAnswer.map((answer, index) => (
                answer === word && (
                  <span className="absolute top-10 left-5 whitespace-nowrap text-red">{answers[index].name}</span>
                )
              ))}
            </span>
          )
        )}
      </div>
      <div className="absolute w-[80%] top-[52%] left-1/2 translate-x-[-50%] answer__wrapper max-w-[400px]">
        {reason}
      </div>
    </div>
  );
};

export default Answer;